var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: [_vm.$style.primaryOpsContactContainer]
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('ProfilePicture', {
    class: _vm.$style.profilePicture,
    attrs: {
      "src": _vm.primaryOpsContact.photoUrl
    }
  }), _c('div', {
    class: _vm.$style.contentContainer
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('p', {
    staticClass: "button-text color-primary-blue",
    class: _vm.$style.name
  }, [_vm._v(" " + _vm._s(_vm.primaryOpsContact.firstName) + " " + _vm._s(_vm.primaryOpsContact.lastName) + " ")]), _c('p', {
    staticClass: "p2 color-primary-blue mb-2"
  }, [_vm._v(_vm._s(_vm.role))])]), _c('div', {
    class: _vm.$style.buttonContainer
  }, [_c('MottoIcon', {
    attrs: {
      "id": "primary-ops-phone",
      "tabindex": "0",
      "name": "Phone",
      "icon-color": "green"
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.handlePhoneClick.apply(null, arguments);
      }
    }
  }), _c('b-tooltip', {
    attrs: {
      "triggers": _vm.isMobile ? '' : 'click blur',
      "target": "primary-ops-phone",
      "placement": "top",
      "custom-class": "tooltipBlue ".concat(_vm.$style.copyToClipboardTooltip)
    }
  }, [_c('span', {
    staticClass: "px-1 py-1",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(" " + _vm._s(_vm.formatPhoneWithDashes(_vm.primaryOpsContact.phone)) + " ")]), _c('CopyToClipboardButton', {
    attrs: {
      "text-to-copy": _vm.primaryOpsContact.phone,
      "theme": "square",
      "icon": "Copy"
    }
  })], 1), _c('a', {
    attrs: {
      "href": "mailto:".concat(_vm.primaryOpsContact.primaryEmail)
    }
  }, [_c('MottoIcon', {
    attrs: {
      "name": "Envelope",
      "icon-color": "green"
    }
  })], 1), _vm.primaryOpsContact.calendlyLink ? _c('MottoIcon', {
    attrs: {
      "name": "Calendar",
      "icon-color": "green"
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.openCalendly.apply(null, arguments);
      }
    }
  }) : _vm._e()], 1)])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }